<template>
	<div id="fork" class="jon-slider">
		<h3 class="text-center mt-5" style="line-height: 1.5em"><b class="text-gradient">Fork</b></h3>
		<p class="text-center font-courier text-gold">Repository dengan forks terbanyak</p>
		<div class="row">
			<div v-for="(f) in fork" :key="f.name" class="col-sm-6 my-3">
				<img :src="profil.avatar_url" width="16" height="16" class="avatar mr-1">
				<a :href="'https://github.com/' + username">{{username}}</a> / <a :href="'https://github.com/' + username + '/' + f.name">{{f.name}}</a> <span class="badge badge-primary">{{f.data.length}}</span>
				<div v-for="(d, i) in f.data" :key="d.id">
					<svg v-if="i != f.data.length-1" xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 20 26" class="gh-icon">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0V13H20V14H10V26H9V0H10Z"></path>
					</svg>
					<svg v-if="i == f.data.length-1" xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 20 26" class="gh-icon">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0V13H20V14H9V0H10Z"></path>
					</svg>
					<img :src="d.owner.avatar_url" width="16" height="16" class="avatar mr-1">
					<a :href="'https://github.com/' + d.owner.login" class="text-white">{{d.owner.login}}</a> / <a :href="'https://github.com/' + d.owner.login + '/' + d.name" class="text-white">{{d.name}}</a>
				</div>
			</div>
		</div>
		<div v-if="stat.fork > 1" class="section-fade"></div>
		<div class="review-fork">
			<div class="row">
				<div class="col-md-6">
					<p class="text-center">Jumlah Fork Sampai Saat Ini</p>
					<CounterStyle identify="statfork" :value="stat.fork" :key="7"></CounterStyle>
				</div>
				<div class="col-md-6">
					<p class="text-center">Jumlah Fork Yang Ingin Anda Capai (2021)</p>
					<CounterStyle identify="resofork" :value="resolution.fork" :key="8" :is_res="true"></CounterStyle>
				</div>
			</div>
			<ReviewBox :stat="stat.fork" :reso="resolution.fork" :progress="progress.fork" identify="fork" :key="4"></ReviewBox>
		</div>
	</div>
</template>

<script>
import CounterStyle from './../components/CounterStyle'
import ReviewBox from './../components/ReviewBox'
export default {
	data(){
		return {
			// number: []
		}
	},
	components: {
		CounterStyle, ReviewBox
	},
	props: ['stat', 'resolution', 'progress', 'fork', 'profil', 'username'],
	methods: {

	},
	mounted(){

	}
}
</script>

<style>
	
</style>